export default "__VITE_ASSET__D8cV607g__"